import { createFileRoute, notFound } from '@tanstack/react-router';
import { AuthorPage } from '../../../pages/blog/AuthorPage';
import { NotFoundPage } from '../../../pages/NotFoundPage';
import { getAuthorBySlug, authorUrl } from '../../../lib/blog/authors';
import { breadcrumbGraph } from '../../../lib/seo/breadcrumb';

export const Route = createFileRoute('/_site/blog/author/$id')({
  loader: ({ params }) => {
    const author = getAuthorBySlug(params.id);
    if (!author) throw notFound();
    return { author };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { author } = loaderData;
    const url = authorUrl(author.slug);
    return {
      meta: [
        { title: `${author.name} - ${author.title}` },
        { name: 'description', content: author.bio },
        { property: 'og:type', content: 'profile' },
        { property: 'og:title', content: author.name },
        { property: 'og:description', content: author.bio },
        { property: 'og:url', content: url },
        { property: 'og:image', content: `https://getanyapi.com${author.photo}` },
        {
          'script:ld+json': breadcrumbGraph(
            { name: 'Blog', url: 'https://getanyapi.com/blog' },
            { name: author.name, url },
          ),
        },
      ],
      links: [{ rel: 'canonical', href: url }],
    };
  },
  component: AuthorRoute,
});

function AuthorRoute() {
  const { id } = Route.useParams();
  const author = getAuthorBySlug(id);
  if (!author) return <NotFoundPage />;
  return <AuthorPage author={author} />;
}
